function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgOot = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.26 18.745c-1.23.013-2.263-.209-3.237-.693-.06-.03-.105-.031-.165.003a5.385 5.385 0 01-1.913.646c-.288.038-.579.078-.869.019a1.025 1.025 0 01-.56-1.695c.344-.39.602-.848.758-1.345a.161.161 0 00-.02-.15 6.43 6.43 0 01-.958-2.788c-.22-2.192.461-4.069 2.032-5.608a6.437 6.437 0 013.647-1.803c1.903-.278 3.637.161 5.16 1.341 1.36 1.053 2.205 2.44 2.5 4.133.374 2.144-.167 4.053-1.605 5.685-1.063 1.206-2.413 1.923-4.001 2.177-.302.048-.607.062-.77.078zm-4.823-1.791l.105-.03c.427-.144.83-.35 1.195-.613.264-.186.525-.195.803-.036a4.86 4.86 0 001.923.628c1.115.119 2.168-.093 3.109-.698 1.627-1.044 2.437-2.547 2.35-4.493-.057-1.246-.545-2.323-1.43-3.2-1.065-1.056-2.362-1.537-3.864-1.434-1.012.071-1.928.419-2.707 1.07-1.51 1.26-2.092 2.875-1.758 4.812.11.637.364 1.222.722 1.762a.825.825 0 01.129.674 6.12 6.12 0 01-.36 1.087c-.067.153-.139.302-.216.47h-.001zm4.568-7.81l.428.868c.15.308.304.615.45.926.037.081.088.11.172.12.63.088 1.259.18 1.888.271l.07.015c-.116.12-.224.238-.337.348-.356.347-.712.693-1.07 1.036-.063.06-.087.117-.07.209.112.632.217 1.266.323 1.9l.005.063c-.035-.014-.061-.022-.085-.035-.556-.293-1.114-.586-1.668-.883-.075-.041-.134-.045-.212-.003-.557.298-1.118.591-1.678.885-.023.013-.046.023-.09.044.028-.17.052-.323.078-.474.088-.512.176-1.024.27-1.535.014-.075-.028-.11-.07-.151-.448-.439-.895-.878-1.343-1.314-.026-.026-.062-.04-.093-.06l.023-.036.687-.098c.432-.062.864-.125 1.296-.184.07-.01.1-.047.13-.105.282-.577.568-1.152.852-1.728.01-.02.022-.04.045-.078z",
    fill: "white"
  }));
});
SvgOot.displayName = "SvgOot";
SvgOot.defaultProps = {
  size: 24,
  color: "#25AAE1"
};
export default SvgOot;